import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Carousel from '../Carousel';
import CarouselItem from '../CarouselItem';
import VHSQuote, { IVHSQuoteProps } from '../VHSQuote';
import {kebabCase} from 'lodash';
import {ICategoryData, IDepartmentData} from "../VHSRecentPosts";

export interface IVHSTestimonialsProps extends IBaseElementProps {
	/**
	 * @control uniqueid
	 */
	id?: string;
	/**
	 * Style
	 */
	style: 'default' | 'wide';
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Text
	 */
	text?: string;
	/**
	 * Automatic Quotes (based on context of view).  Please leave the sample testimonials within the block, as the code will replace them with actual quotes on the page.
	 */
	automaticQuotes?: boolean;
	/**
	 * @taxonomy category
	 * Leave blank to allow automatic detection
	 */
	categories?: ICategoryData[];
	/**
	 * @taxonomy department
	 * Leave blank to allow automatic detection
	 */
	departments?: IDepartmentData[];
	/**
	 * Quotes
	 */
	quotes?: IVHSQuoteProps[];
}

/**
 * Testimonials
 * @block
 * @icon sticky
 * @requiresHooks
 */
const VHSTestimonials: React.FC<IVHSTestimonialsProps> = ({
	id,
	style,
	heading,
	text,
	quotes = [],
}) => {
	const peek = (style!='wide') ? 284 : 406;
	const carouselOptions = {
		type: 'carousel',
		rewind: false,
		bound: true,
		gap: 32,
		perView: 1,
		peek: {
			before: 0,
			after: peek,
		},
		breakpoints: {
			640: {
				perView: 1,
				peek: {
					before: 0,
					after: 0,
				},
			},
			765: {
				perView: 1,
				peek: {
					before: 0,
					after: 0,
				},
			},
			900: {
				perView: 1,
				peek: {
					before: 0,
					after: 0,
				},
			},
			1140: {
				perView: 1,
				peek: {
					before: 0,
					after: 0,
				},
			},
		},
	};
	return (
		<>
			{quotes.length > 0 &&
			<div
				className={cn(
					'vhs-testimonials',
					(style === 'wide') && 'vhs-testimonials--wide',
				)}
			>
				<div className="vhs-testimonials__container">
					{heading && <h2 className="vhs-testimonials__heading">{heading}</h2>}
					{text && <p className="vhs-testimonials__text">{text}</p>}
					<div className="vhs-testimonials__wrapper">
						<Carousel
							perView={1}
							options={carouselOptions}
							id={`testimonials-${kebabCase(heading)}`}
						>
							{quotes.map((quote, index) => (
								<CarouselItem key={index}>
									<VHSQuote
										{...quote}
									/>
								</CarouselItem>
							))}
						</Carousel>
					</div>
				</div>
			</div>
			}
		</>
	);
};

export default VHSTestimonials;
